import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d3b9d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "type"]
const _hoisted_2 = { class: "button_text" }
const _hoisted_3 = { class: "spinner" }

import Icon from '@/components/atoms/Icon.vue'
import Spinner from '@/components/atoms/Spinner.vue'
import { withDefaults, computed } from 'vue'

type PropsType = {
  icon?: string
  iconPosition?: string
  useBorder?: boolean
  disabled?: boolean
  color?: string
  size?: string
  iconColor?: string
  iconSize?: string
  type?: string
  loading?: boolean
  useFullButton?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleButton',
  props: {
    icon: null,
    iconPosition: { default: 'left' },
    useBorder: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    color: { default: '' },
    size: { default: 'size-m' },
    iconColor: { default: '' },
    iconSize: { default: '' },
    type: { default: 'button' },
    loading: { type: Boolean, default: false },
    useFullButton: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { icon?: string, iconPosition: string, useBorder: boolean, disabled: boolean, color: string, size: string, iconColor: string, iconSize: string, type: string, loading: boolean, useFullButton: boolean };





const spinnerSize = computed<string>(() => {
  // TODO size-mかsize-sしかない為。増えたら変更する必要がある
  return props.size === 'size-s' ? '10px' : '20px'
})

const showIcon = computed<(position: string) => boolean>(() => {
  return (position: string) => {
    return !!props.icon && !props.loading && position === props.iconPosition
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["link_scale_s", [{ border: __props.useBorder, fullButton: __props.useFullButton }, __props.size, __props.color]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    disabled: __props.disabled || __props.loading,
    type: __props.type
  }, [
    _createElementVNode("span", _hoisted_2, [
      _withDirectives(_createVNode(Icon, {
        class: "left",
        type: __props.icon,
        color: __props.iconColor,
        size: __props.iconSize
      }, null, 8, ["type", "color", "size"]), [
        [_vShow, _unref(showIcon)('left')]
      ]),
      _withDirectives(_createElementVNode("span", _hoisted_3, [
        _createVNode(Spinner, {
          color: __props.iconColor,
          size: _unref(spinnerSize)
        }, null, 8, ["color", "size"])
      ], 512), [
        [_vShow, __props.loading]
      ]),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _withDirectives(_createVNode(Icon, {
        class: "right",
        type: __props.icon,
        color: __props.iconColor,
        size: __props.iconSize
      }, null, 8, ["type", "color", "size"]), [
        [_vShow, _unref(showIcon)('right')]
      ])
    ])
  ], 10, _hoisted_1))
}
}

})